import Loader from "react-loader-spinner";
import { Fragment, useEffect, useState } from "react";
import { getServiceCountByStage, getServiceCountByStatus } from "../store/api/Services";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import DatePicker from "react-datepicker2";
import { BarChartFill, List, Printer } from "react-bootstrap-icons";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartArea } from "@fortawesome/free-solid-svg-icons";
import { Bar, BarChart, CartesianGrid, Label, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ServiceCountByStageReport = () => {
    const history = useHistory();
    const [dateFilters, setDateFilters] = useState({});
    const [dataList, setDataList] = useState(null);
    const [popStaff, setPopStaff] = useState({ show: false });
    const [selectedStaff, setSelectedStaff] = useState(null);
    const renderLegend = (props) => {
        const { payload } = props;
        return (
            <Fragment>
                {
                    payload.map((entry, index) => (
                        <span key={`item-${index}`} style={{ color: `${entry.color}`, fontSize: "11px" }}>
                            <div style={{ backgroundColor: `${entry.color}`, width: "10px", height: "10px", display: "inline-block" }}></div>
                            &nbsp;{entry.value.replace("Count", "تعداد")}
                        </span>
                    ))
                }
            </Fragment>
        );
    }
    function search() {
        const data = {};
        const dateFrom = document.getElementsByName("DateFrom")[0].value;
        if (dateFrom !== "") {
            data.DateFrom = dateFilters.DateFrom;
            data.PDateFrom = dateFrom;
        }
        else {
            dateFilters.DateFrom = null;
        }
        const dateTo = document.getElementsByName("DateTo")[0].value;
        if (dateTo !== "") {
            data.DateTo = dateFilters.DateTo;
            data.PDateTo = dateTo;
        }
        else {
            dateFilters.DateTo = null;
        }
        const archiveDateFrom = document.getElementsByName("ArchiveDateFrom")[0].value;
        if (archiveDateFrom !== "") {
            data.ArchiveDateFrom = dateFilters.ArchiveDateFrom;
            data.PArchiveDateFrom = archiveDateFrom;
        }
        const archiveDateTo = document.getElementsByName("ArchiveDateTo")[0].value;
        if (archiveDateTo !== "") {
            data.ArchiveDateTo = dateFilters.ArchiveDateTo;
            data.PArchiveDateTo = archiveDateTo;
        }
        data.StaffID = selectedStaff?.ID;
        setDataList("PENDING");
        getServiceCountByStage(data.StaffID, data.DateFrom ?? "", data.DateTo ?? "", data.ArchiveDateFrom ?? "", data.ArchiveDateTo ?? "", setDataList);

    }
    function showModalStaff(e) {
        if (e.key && !keyIsLetterOrNumber(e.keyCode, e.key)) {
            return;
        }
        setPopStaff({
            show: true,
            value: e?.target?.key ?? "",
            onSelect: setSelectedStaff
        })
    }
    function print(e) {
        history.push({
            pathname: `/PrintViewer/ServiceCountByStage/${e.ctrlKey ?? false}`,
            state: {
                //     dataUrl: `api/ServiceReportsAPI/GetServiceCountByStage?dateFrom=${dateFilters.DateFrom}&dateTo=${dateFilters.DateTo}`,
                //     method: "post",
                //     fetchBody:selectedStaff?.ID
                jsonObject: dataList?.Data
            }
        });

    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";

    })
    return (
        <div className="container-fluid mt-1">
            <br />
            <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />
            <Card style={{ textAlign: "right" }}>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faChartArea} size="lg" />&nbsp;
                    گزارش ورود و خروج سیستم خدمات
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <Row className="rowBorder">
                        <Col md={2} className="form-group">
                            <label>تاریخ پذیرش از: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="DateFrom" onChange={val => dateFilters.DateFrom = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ پذیرش تا: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="DateTo" onChange={val => dateFilters.DateTo = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ بایگانی از: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="ArchiveDateFrom"
                                onChange={val => dateFilters.ArchiveDateFrom = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ بایگانی تا: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="ArchiveDateTo"
                                onChange={val => dateFilters.ArchiveDateTo = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>نام تکنسین: </label>
                            <Form.Control name="StaffName" readOnly value={selectedStaff?.LastName ?? ""} onKeyDown={showModalStaff} />
                            <Button className="btn-input-tiny" onClick={showModalStaff} style={{ top: 26 }}><List size={23} /></Button>
                        </Col>
                    </Row>
                    <Button className="group-Btn-large mt-1" onClick={search}>
                        <BarChartFill size={18} />&nbsp; خروجی گزارش
                    </Button>
                    <Button variant="secondary" className="group-Btn-large mt-1" onClick={print} disabled={!dataList?.Data}>
                        <Printer size={18} />&nbsp; چاپ گزارش
                    </Button>
                    <Row style={{ margin: 0 }}>
                        <Col md={4} style={{ overflow: "auto" }}>
                            <Table className="mt-1" style={{ whiteSpace: "nowrap" }}>
                                <thead >
                                    <th style={{ padding: "5px" }}>مرحله</th>
                                    <th style={{ padding: "5px" }}>تعداد</th>
                                </thead>
                                <tbody>
                                    {dataList?.Data &&
                                        dataList.Data.map((data, i) => <tr key={i} className="resultTableRow">
                                            <td>{data.Stage}</td>
                                            <td>{data.Count}</td>
                                        </tr>)}
                                    {dataList === "PENDING" &&
                                        <tr>
                                            <td colSpan={2} style={{ width: "100%", textAlign: "center" }}>
                                                <Loader type="BallTriangle" color="#bb1370" width={25} height={25} />
                                            </td>
                                        </tr>
                                    }
                                    {dataList?.Error &&
                                        <tr>
                                            <td colSpan={2} style={{ width: "100%", textAlign: "center", color: "red" }}>
                                                {dataList.Error}
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </Table>
                        </Col>
                        <Col md={8} style={{ textAlign: "center" }}>
                            {dataList?.Data &&
                                <ResponsiveContainer width="100%" height="100%" className="barChart" debounce={300}>
                                    <BarChart data={dataList.Data}>
                                        {/* <Legend align="left" verticalAlign="bottom" content ={renderLegend}/> */}
                                        <XAxis dataKey="Stage" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100}>
                                            <Label value="مرحله سرویس" offset={2} position="insideBottom" style={{ fill: "blue" }} />
                                        </XAxis>
                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5}
                                            label={{ value: "تعداد", angle: 90, style: { fill: "blue" } }} />
                                        <CartesianGrid />
                                        <Bar dataKey="Count" fill="#05386b" label={{ position: 'top' }} isAnimationActive={false} />
                                    </BarChart>
                                </ResponsiveContainer>
                            }
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    )
}
export default ServiceCountByStageReport;